import { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { FiUser } from 'react-icons/fi';
import { Form, FormInstance } from 'antd';
import type { TooltipPlacement } from 'antd/es/tooltip';
import SelectUserAvatar from 'components/SelectUserAvatar';
import { RootState } from 'store';
import { UserResponse } from 'types';

interface SelectResponsibleProps {
  state: any;
  label?: ReactNode;
  form: FormInstance;
  setState: any;
  finalProjectId?: any;
  finalProject?: any;
  dropdownMatchSelectWidth?: boolean | number;
  onlyAvatar?: boolean;
  bordered?: boolean;
  disabled?: boolean;
  value?: any;
  onChange?: (value: any, option: any) => void;
  required?: boolean;
  noStyle?: boolean;
  planInput?: boolean;
  avatarPopover?: boolean;
  avatarPopoverPlacement?: TooltipPlacement;
}

const SelectResponsible: FC<SelectResponsibleProps> = ({
  state,
  label,
  form,
  setState,
  finalProjectId,
  finalProject,
  dropdownMatchSelectWidth,
  onlyAvatar,
  bordered,
  disabled,
  value,
  onChange,
  required = true,
  planInput = false,
  avatarPopover = false,
  avatarPopoverPlacement,
}) => {
  const user = useSelector((store: RootState) => store.auth.user) as UserResponse;

  const stateResponsible = state?.responsibles?.[0];

  const defaultResponsibleOptions = [
    { value: user.uuid, label: user.name, user },
    ...(stateResponsible && stateResponsible.uuid !== user.uuid
      ? [
          {
            value: stateResponsible.uuid,
            label: stateResponsible.name,
            user: stateResponsible,
          },
        ]
      : []),
  ];

  const project = finalProject?.project ?? finalProject;

  return (
    <Form.Item
      className="ant-form-responsible-item"
      style={{ marginBottom: 0 }}
      label={
        label ?? (
          <>
            <FiUser />
            Assignee
          </>
        )
      }
      name="responsibles"
      help={null}
      rules={[
        {
          required,
          message: 'Assignee is required',
        },
      ]}
    >
      <SelectUserAvatar
        mentionables
        planInput={planInput}
        placeholder="Select a user"
        size="middle"
        projectId={finalProjectId}
        project={project}
        defaultOptions={defaultResponsibleOptions}
        filterType={['regular_user', 'freelancer']}
        filters={{
          'sort[by]': 'name',
          'filters[billing_contacts.status][]': 'active',
          'filters[type][]': ['regular_user', 'freelancer'],
        }}
        bordered={bordered}
        dropdownMatchSelectWidth={dropdownMatchSelectWidth}
        disabled={disabled}
        onlyAvatar={onlyAvatar}
        avatarPopover={avatarPopover}
        avatarPopoverPlacement={avatarPopoverPlacement}
        value={value}
        onChange={(val, option) => {
          setState((prevState: any) => {
            const newResponsibles = option ? [option.user] : [];
            return { ...prevState, responsibles: newResponsibles };
          });

          const newFollowers = option ? state?.followers?.filter((x: any) => x.uuid !== option.value) : state?.followers;

          if (newFollowers && newFollowers.length !== state.followers.length) {
            const ids = newFollowers.map((x: any) => x.uuid);
            setState((prevState: any) => ({ ...prevState, followers: newFollowers }));
            form.setFieldsValue({ followers: ids });
          }

          if (onChange) {
            onChange(val, option);
          }
        }}
      />
    </Form.Item>
  );
};

export default SelectResponsible;
